<template>
  <div v-if="commonData">
    <!-- Shape Start -->
    <proglass-section-shape v-if="shape" :color="shape.color" :type="shape.type" />
    <!--Shape End-->
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <router-link class="logo-footer" to="/">
              <img :src="logo" height="120" alt="Footer Logo" />
            </router-link>
            <p class="mt-4">
              <proglass-markdown :source="content" />
            </p>
            <ul class="list-unstyled social-icon social mb-0 mt-4">
              <li class="list-inline-item">
                <a :href="socialNetworks.facebook" class="btn btn-icon btn-pills" target="_blank">
                  <facebook-icon class="fea icon-sm fea-social" />
                </a>
              </li>
              <li class="list-inline-item ml-1">
                <a :href="socialNetworks.instagram" class="btn btn-icon btn-pills" target="_blank">
                  <instagram-icon class="fea icon-sm fea-social" />
                </a>
              </li>
            </ul>
            <!--end icon-->
          </div>
          <!--end col-->

          <div class="col-lg-2 col-md-6 col-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h4 class="text-light footer-head">{{ $t('ui.label.footerFirstMenu') }}</h4>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <router-link to="/our-company" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{ $t('menu.ourCompany') }}
                </router-link>
              </li>
              <li>
                <router-link to="/what-we-do" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{ $t('menu.whatWeDo') }}
                </router-link>
              </li>
              <li>
                <router-link to="/projects" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{ $t('menu.projects') }}
                </router-link>
              </li>
              <li>
                <router-link to="/contact" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{ $t('menu.contact') }}
                </router-link>
              </li>
            </ul>
          </div>
          <!--end col-->

          <div class="col-lg-3 col-md-6 col-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h4 class="text-light footer-head">{{ $t('ui.label.footerSecondMenu') }}</h4>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <router-link to="/legal/advertisement" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{ $t('page.legal.advertisement') }}
                </router-link>
              </li>
              <li>
                <router-link to="/legal/privacy" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{ $t('page.legal.privacy') }}
                </router-link>
              </li>
              <li>
                <router-link to="/legal/cookies" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{ $t('page.legal.cookies') }}
                </router-link>
              </li>
            </ul>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
    <footer class="footer footer-bar">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col">
            <div class="text-sm-left">
              <p class="mb-0">
                © {{ new Date().getFullYear() }} Pro Glass & Shower Doors Corp.
                {{ $t('message.generic.madeWith') }} <i class="mdi mdi-heart text-danger"></i>
                {{ $t('message.generic.inCity') }}
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
  </div>
</template>

<script>
import { FacebookIcon, InstagramIcon } from 'vue-feather-icons';

export default {
  name: 'Footer',

  components: {
    FacebookIcon,
    InstagramIcon
  },

  data: () => ({}),

  computed: {
    commonData() {
      return this.$store.getters['website/dataWebsite']('commonApp');
    },

    logo() {
      return this.commonData.footer.logo.url;
    },

    content() {
      return this.commonData.footer.content;
    },

    shape() {
      return this.commonData.footer.shape;
    },

    socialNetworks() {
      return this.commonData.socialNetworks;
    }
  }
};
</script>
